// we use custom heading size for hero banner
// eslint-disable-next-line no-restricted-imports
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import useIsMobile from 'lib/hooks/useIsMobile';
import RewardsButton from 'ui/rewards/RewardsButton';
import AdBanner from 'ui/shared/ad/AdBanner';
import SearchBar from 'ui/snippets/searchBar/SearchBarDesktop';
import SearchBarMobile from 'ui/snippets/searchBar/SearchBarMobile';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

export const BACKGROUND_DEFAULT = 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #FF8C00 100%)';
const TEXT_COLOR_DEFAULT = 'white';
const BORDER_DEFAULT = 'none';

const HeroBanner = () => {

  const isMobile = useIsMobile();

  const background = {
    _light:
      config.UI.homepage.heroBanner?.background?.[0] ||
      BACKGROUND_DEFAULT,
    _dark:
      config.UI.homepage.heroBanner?.background?.[1] ||
      config.UI.homepage.heroBanner?.background?.[0] ||
      BACKGROUND_DEFAULT,
  };

  const textColor = {
    _light:
      // light mode
      config.UI.homepage.heroBanner?.text_color?.[0] ||
      TEXT_COLOR_DEFAULT,
    // dark mode
    _dark:
      config.UI.homepage.heroBanner?.text_color?.[1] ||
      config.UI.homepage.heroBanner?.text_color?.[0] ||
      TEXT_COLOR_DEFAULT,
  };

  const border = {
    _light:
      config.UI.homepage.heroBanner?.border?.[0] || BORDER_DEFAULT,
    _dark:
      config.UI.homepage.heroBanner?.border?.[1] || config.UI.homepage.heroBanner?.border?.[0] || BORDER_DEFAULT,
  };

  return (
    <Flex
      w="100%"
      background={ background }
      border={ border }
      borderRadius="lg"
      p={{ base: 4, lg: 6 }}
      columnGap={ 6 }
      alignItems="center"
      boxShadow="0 2px 10px rgba(0, 0, 0, 0.15)"
      position="relative"
      overflow="hidden"
      minH="80px"
    >
      <Box
        position="absolute"
        top="-50%"
        left="-10%"
        width="50%"
        height="200%"
        background="radial-gradient(circle, rgba(255, 140, 0, 0.1) 0%, rgba(0, 0, 0, 0) 70%)"
        transform="rotate(30deg)"
        pointerEvents="none"
      />
      <Box flexGrow={ 1 } zIndex={ 1 }>
        <Box mb={{ base: 3, lg: 4 }}>
          <Heading
            as="h1"
            fontSize={{ base: '20px', lg: '28px' }}
            lineHeight={{ base: '28px', lg: '36px' }}
            fontWeight={{ base: 600, lg: 700 }}
            color={ textColor }
            textShadow="0 1px 2px rgba(0,0,0,0.3)"
            letterSpacing="tight"
          >
            Xhavic Blockchain Explorer
          </Heading>
          <Text
            mt={ 1 }
            fontSize={{ base: 'xs', lg: 'sm' }}
            color={ textColor }
            opacity={ 0.85 }
            textShadow="0 1px 2px rgba(0,0,0,0.3)"
          >
            Search and explore blocks, transactions, addresses, and tokens on the Xhavic network in real time.
          </Text>
        </Box>
        <Flex justifyContent="space-between" alignItems="center" columnGap={ 4 } flexWrap="wrap">
          <Box flexGrow={ 1 } maxW="800px">
            <Box display={{ base: 'flex', lg: 'none' }}>
              <SearchBarMobile isHeroBanner/>
            </Box>
            <Box display={{ base: 'none', lg: 'flex' }}>
              <SearchBar isHeroBanner/>
            </Box>
          </Box>
          { config.UI.navigation.layout === 'horizontal' && (
            <Box display={{ base: 'none', lg: 'flex' }} gap={ 3 }>
              { config.features.rewards.isEnabled && <RewardsButton variant="hero"/> }
              {
                (config.features.account.isEnabled && <UserProfileDesktop buttonVariant="hero"/>) ||
                (config.features.blockchainInteraction.isEnabled && <UserWalletDesktop buttonVariant="hero"/>)
              }
            </Box>
          ) }
        </Flex>
      </Box >
    </Flex >
  );
};

export default React.memo(HeroBanner);
